import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { startCase } from 'lodash';
import { ValidPlans } from '../types';

export interface PlanChipProps {
  plan: ValidPlans;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

const PlanChip = ({ plan, fullWidth, size = 'small' }: PlanChipProps) => {
  const theme = useTheme();
  const smallScreen = theme.breakpoints.down('sm');
  const fontSize = smallScreen ? '12px' : '14px';

  const sx = {
    fontWeight: 600,
    color: 'primary.contrastText',
    position: 'relative',
    width: fullWidth ? '100%' : 'auto',
    fontSize,
    bgcolor: 'primary.main',
    '&:focus, &:active, &:hover': {
      fontWeight: 600,
      bgcolor: 'primary.main',
    },
  };

  return (
    <Chip label={startCase(plan)} sx={sx} className="plan-chip" size={size} />
  );
};

export default PlanChip;
